import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Logger } from '../services/logger-service';
@Injectable({
  providedIn: 'root'
})
export class HealthCheckService {
  constructor(protected http: HttpClient, private logger: Logger) { }

  public healthcheck$(): Observable<boolean> {
    const url = `${environment.apiUrl}`.replace('/api', '/healthcheck');
    return this.http.get<any>(url)
      .pipe(map(result => {
        this.logger.info('HealthCheck', result);
        return true;
      }));
  }
}
